import React, { FC } from 'react';

import { Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';

import SecuredSystemsV2Img from '~/components/organisms/SolidCheckout/assets/secured_systems_v2.webp';
import { Typographies } from '~/theme/typography';

import styles from './styles.module.scss';

const Guarantee: FC = () => {
  const { t } = useTranslation('');

  return (
    <div className={styles.guarantee}>
      <img src={SecuredSystemsV2Img} alt="" className={styles.guarantee__img} />

      <Typography
        className={styles.guarantee__text}
        variant={Typographies.LABEL_MEDIUM}
        component="h3"
      >
        {t('general:payments_secured', 'Payments secured')}
      </Typography>
    </div>
  );
};

export default Guarantee;
